import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MeddraBrowserComponent } from '../meddra-browser/meddra-browser.component';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';

 interface BasketTerms {
  type: 'TERM';
  level: string;
  code: string;
  name: string;
}

 interface BasketPayload {
  basketName: string;
  basketDescription: string;
  basketType: string;
  basketGroup:string;
  terms: BasketTerms[];
  state: string;
}

@Component({
    selector: 'app-meddra-basket-creation',
    templateUrl: './meddra-basket-creation.component.html',
    styleUrls: ['./meddra-basket-creation.component.scss'],
    standalone: false
})
export class MeddraBasketCreationComponent implements OnInit {

  isSubmitting = false;
  isEditing = false;
  existingBasketId: string | null = null;

  // Grid Properties
  selectedBasket = {
    name: '',
    type: '',
    group: '',
    version: '',
    description: '',
    items: [] as any[]
  };

  termsColumnDefs: any[] = [];
  defaultColDef: any = {};
  
  // UI Flags
  hasPublishPermission = false;
  showIncomingItems = false;
  incomingItemsCount = 0;

  // Pagination
  termsPageSize = 10;
  termsPaginationPageSize = 10;
  termsCurrentPage = 1;
  termsTotalPages = 1;

  // Workflow states
  workflowStates = {
    DRAFT: 'Draft',
    SUBMITTED: 'In Review',
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED'
  };
  backgroundColorScreen: any;
  backgroundColorButton: any;

selectedExistingCmq: any;
existingCmqList = [];
typeOptions = [
  { value: 'PRBRER', label: 'PRBRER Basket' },
  { value: 'PCB', label: 'Pregancy Case Basket' },
  { value: 'FCB', label: 'Fatal Case Basket' }
];

groupOptions = [
  { value: 'GQ', label: 'Guided Questionaire' },
  { value: 'Al', label: 'Auto Labelling' },
  { value: 'Always', label: 'Always Seriousness' },
  { value: 'IME', label: 'IME' },
  { value: 'DME', label: 'DME' },
  { value: 'TME', label: 'TME' },
  { value: 'AR', label: 'Aggregate Report' },
  { value: 'PR', label: 'Product Specific' }
];
basketForm!: FormGroup;
selectedItems: any[] = [];



  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MeddraBasketCreationComponent>,
    private router: Router,
    private dialog: MatDialog,
    private localStorage: LocalStorageSettingsService,
        private snackBar: MatSnackBar,
        private spinner: NgxUiLoaderService,
         private jsignalsService: JsignalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

    ngOnInit() {
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.initBasketForm();
    console.log(this.data);
    //patch the values of the selected  medra version 
      this.patchFormValues({
    meddraVersion: this.data?.medDraVersion?.label,
     });
    if (this.data?.selectedTerms) {
    this.selectedItems = [...this.data.selectedTerms];
    }
    }

  
initBasketForm() {
  this.basketForm = this.fb.group({
    basketName: ['', Validators.required],
    basketType: ['', Validators.required],
    basketGroup: ['', Validators.required],
    meddraVersion: ['', Validators.required],
    basketDescription: [''],

    // Example: If you need language or MedDRA fields later:
    // language: [this.languageOptions[0]],
    // meddraVersion: [null]
  });
}
  closeEditor(): void {
    this.onCancel();
  }

  saveBasket(): void {
  if (this.basketForm.invalid) {
    this.basketForm.markAllAsTouched();
    return;
  }
    this.saveAsDraft();
  }

  publishBasket(): void {
  if (this.basketForm.invalid) {
    this.basketForm.markAllAsTouched();
    return;
  }
    this.submitForReview();
  }

 
  // -----------------------------
  // SAVE / SUBMIT ACTIONS
  // -----------------------------
  saveAsDraft(): void {
 const formValue = this.basketForm.value;

  // ---- MAP TERMS INTO STRONG TYPED INTERFACE ----
  const terms: BasketTerms[] = (this.selectedItems ?? []).map(t => {
    return {
      type: 'TERM',
      level: t.level,
      code: t.code,
      name: t.name
    };
  });

  // ---- FINAL PAYLOAD ----
  const payload: BasketPayload = {
    basketName: formValue.basketName,
    basketDescription: formValue.basketDescription,
    basketType: formValue.basketType,
    basketGroup:formValue.basketGroup,
    terms: terms,
    state: this.workflowStates.DRAFT
  };

  console.log('FINAL PAYLOAD:', payload);
  this.spinner.start();

  // API Call -->
   this.jsignalsService.createBasket(payload).subscribe({
      next: (response) => {
        console.log(response);
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
        if(response.statusMessage =='Basket with the same name already exists'){
          // Keep the user on the form to change the name 
        }else{
           this.onBack();
        } 
        
      },
      error: (err) => {
        console.error('Error creating basket', err);
        this.spinner.stop();
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        this.onBack();
      }
    });
  }

  // In MeddraBasketCreationComponent - update the submitForReview method:

submitForReview(): void {
    if (this.basketForm.invalid) {
    this.basketForm.markAllAsTouched();
    return;
  }

  const formValue = this.basketForm.value;

  // ---- MAP TERMS INTO STRONG TYPED INTERFACE ----
  const terms: BasketTerms[] = (this.selectedItems ?? []).map(t => {
    return {
      type: 'TERM',
      level: t.level,
      code: t.code,
      name: t.name
    };
  });

  // ---- FINAL PAYLOAD ----
  const payload: BasketPayload = {
    basketName: formValue.basketName,
    basketDescription: formValue.basketDescription,
    basketType: formValue.basketType,
    basketGroup:formValue.basketGroup,
    terms: terms,
    state: this.workflowStates.SUBMITTED
  };

  console.log('FINAL PAYLOAD:', payload);
  this.spinner.start();

  // API Call -->
   this.jsignalsService.createBasket(payload).subscribe({
      next: (response) => {
        console.log(response);
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
        if(response.statusMessage =='Basket with the same name already exists'){
          // Keep the user on the form to change the name

        }else{
          this.onBack();
        }
       
      },
      error: (err) => {
        console.error('Error creating basket', err);
        this.spinner.stop();
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        this.onBack();
      }
    });
}

  // -----------------------------
  // NAVIGATION & CANCEL
  // -----------------------------
  onBack(): void {
    this.dialogRef.close({ success: false, action: 'cancelled' });
  }

  onCancel(): void {
    // if (this.hasUnsavedChanges()) {
    //   if (confirm('You have unsaved changes. Are you sure you want to cancel?')) {
    //     this.dialogRef.close({ success: false, action: 'cancelled' });
    //   }
    // } else {
    //   this.dialogRef.close({ success: false, action: 'cancelled' });
    // }
     this.dialogRef.close({ success: false, action: 'cancelled' });
  }

  // -----------------------------
  // NOTIFICATION HELPERS
  // -----------------------------
  private showNotification(message: string): void {
    alert(message);
  }

  patchFormValues(data: any) {
  if (!data) return;

  Object.keys(data).forEach(key => {
    if (this.basketForm.controls[key]) {
      this.basketForm.patchValue({ [key]: data[key] });
    }
  });
}

  clearAllSelections(): void {
    this.selectedItems = [];
    // this.gridApi?.deselectAll();
    this.snackBar.open('All selections cleared', 'Close', { duration: 2000 });
  }

    getProvenanceClass(item: any): string {
    if (item.provenance?.includes('SMQ')) {
      if (item.provenance.includes('Broad')) return 'smq-broad';
      if (item.provenance.includes('Narrow')) return 'smq-narrow';
      if (item.provenance.includes('Both')) return 'smq-both';
    }
    return 'direct';
  }
  removeSelection(index: number): void {
     this.selectedItems.splice(index, 1)[0];
    
    // Deselect in grid if applicable
    // if (this.gridApi && removed.fullRecord) {
    //   this.gridApi.forEachNode((node: any) => {
    //     if (node.data?.fullRecord?.lltCode === removed.fullRecord?.lltCode) {
    //       node.setSelected(false);
    //     }
    //   });
    // }
  }
}